import React from 'react';
import PropTypes from 'prop-types';

const skillSections = [
    ['Essential skills and competences', 'essentialSkillsAndCompetences'],
    ['Essential knowledge', 'essentialKnowledge'],
    ['Optional knowledge', 'optionalKnowledge'],
    ['Optional skills and competences', 'optionalSkillsAndCompetences'],
];

const JobCardItem = ({ job, onDelete }) => {
    const hasSkillsDetails = skillSections.some(([, key]) => Array.isArray(job[key]) && job[key].length > 0);

    return (
        <div className="card h-100 shadow-sm">
            <div className="card-body d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <h5 className="card-title mb-0">{job.title || 'Untitled job'}</h5>
                    <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => onDelete(job.id, job.title || 'this job')}
                        title="Remove job"
                    >
                        <i className="bi bi-trash"></i>
                    </button>
                </div>

                <p className="card-text text-muted flex-grow-1">
                    {job.description || 'No description available.'}
                </p>

                {hasSkillsDetails ? (
                    <details className="mt-2">
                        <summary className="small text-muted fw-semibold">Occupation Details</summary>

                        <div>
                            {skillSections.map(([label, key]) => {
                                const items = job[key];

                                if (!Array.isArray(items) || items.length === 0) {
                                    return null;
                                }

                                return (
                                    <div className="card mt-2" key={label}>
                                        <div className="card-header small fw-semibold text-muted mb-1">{label}</div>
                                        <div className="card-body d-flex flex-wrap gap-1">
                                            {items.slice(0, 6).map((item) => (
                                                <span key={`${label}-${item}`} className="badge text-bg-light border text-wrap">
                                                    {item}
                                                </span>
                                            ))}
                                            {items.length > 6 ? (
                                                <span className="badge text-bg-light border text-muted">
                                                    +{items.length - 6} more
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </details>
                ) : null}

                <div className="d-flex flex-wrap gap-2 mt-3">
                    {job.category ? <span className="badge text-bg-light border">{job.category}</span> : null}
                    {job.type ? <span className="badge text-bg-light border">{job.type}</span> : null}
                </div>
            </div>
        </div>
    );
};

JobCardItem.propTypes = {
    job: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string,
        description: PropTypes.string,
        category: PropTypes.string,
        type: PropTypes.string,
        essentialSkillsAndCompetences: PropTypes.array,
        essentialKnowledge: PropTypes.array,
        optionalKnowledge: PropTypes.array,
        optionalSkillsAndCompetences: PropTypes.array,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default JobCardItem;